import { ApiConfig } from "common/models";
import { buildSearchApiUrl } from "common/utils/api.util";
import {
  HybridSearchRequest,
  HybridKgRequest
} from "../models/search-hub.model";

export const searchHubConfig = {
  hybridSearch: (request: HybridSearchRequest): ApiConfig => {
    return new ApiConfig(
      buildSearchApiUrl("hybrid-search"),
      "POST",
      "",
      request
    );
  },
  hybridKg: (request: HybridKgRequest): ApiConfig => {
    return new ApiConfig(buildSearchApiUrl("hybrid-kg"), "POST", "", request);
  }
};
